import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getGrandAppList = createAsyncThunk('/grand_approval_list/content', async (nopage) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/companySoFileGrandApproval?page=${nopage}`, {})
    return response.data;
})

export const grandAppListSlice = createSlice({
    name: 'grand_approval_list',
    initialState: {
        isLoading: false,
        grand_approval_list: []
    },

   
    extraReducers: (builder) => {
        builder
            .addCase(getGrandAppList.pending, (state) => {
                state.isLoading = true;
            })               
            .addCase(getGrandAppList.fulfilled, (state, action) => {
                state.grand_approval_list = action.payload.data;
                state.isLoading = false;
            })               
            .addCase(getGrandAppList.rejected, (state) => {
                state.isLoading = false;
            });               
    }   
})

export default grandAppListSlice.reducer